import { render, staticRenderFns } from "./unfoldCompanies.vue?vue&type=template&id=1814e9a1&"
import script from "./unfoldCompanies.vue?vue&type=script&lang=js&"
export * from "./unfoldCompanies.vue?vue&type=script&lang=js&"
import style0 from "./unfoldCompanies.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports